import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Checkbox,
} from '@material-ui/core';

import { formatDocMag } from './../../../utils/info-moduli';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '4px',
        padding: '0px',
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    minWidth: {
        minWidth: '100%',
    },
    red: {
        backgroundColor: '#d9534f52',
        paddingTop: '0px',
        paddingBottom: '0px',
        '&:hover': {
            backgroundColor: '#ca535085',
        },
    },
    green: {
        backgroundColor: '#00ff0024',
        paddingTop: '0px',
        paddingBottom: '0px',
        '&:hover': {
            backgroundColor: '#00c50069',
        },
    },
    divider: {
        borderTop: '1px solid #00000021'
    },
    sub: {
        marginLeft: '24px',
    },
});


class ModuliDocMag extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isReadOnly: false,
        };

        this.setupChange = this.setupChange.bind(this);
    }

    componentDidMount() {
        if (this.props.doc_mag.DocMag === false)
            this.setState({ isReadOnly: true });
    }

    componentDidUpdate(propsPrecedenti) {
        //Se cambio profilo predefinito faccio in modo che in caso di attivazione di una checkbox padre le figlie non rimangano disattivate
        if (this.props.doc_mag.DocMag !== propsPrecedenti.doc_mag.DocMag) {
            if (this.props.doc_mag.DocMag === true) this.setState({ isReadOnly: false });
            else this.setState({ isReadOnly: true });
        }
    }

    setupChange(keyName, newValue) {


        if (!this.props.isReadOnly) {
            if (keyName === "DocMag") {
                if (newValue === false) {   //metto a false tutte le checkbox figlie
                    this.props.handleChangeFieldModulo('MagDoc', 'DocMag', newValue);
                    this.props.handleChangeFieldModulo('MagDoc', 'Commesse', newValue);
                    this.props.handleChangeFieldModulo('MagDoc', 'Lotti', newValue);
                    this.props.handleChangeFieldModulo('MagDoc', 'Rapportini', newValue);

                    this.setState({ isReadOnly: true });
                }
                else {
                    this.props.handleChangeFieldModulo('MagDoc', 'DocMag', newValue);

                    this.setState({ isReadOnly: false });
                }
            }
            else {
                this.props.handleChangeFieldModulo('MagDoc', keyName, newValue);
            }
        }

    }

    render() {
        const { classes, doc_mag } = this.props;
        const { isReadOnly } = this.state;

        return (
            <List className={classes.root}>


                {
                    Object.keys(doc_mag).map((keyName, i) => {
                        const labelId = `checkbox-list-label-${keyName}`;

                        return (
                            <ListItem className={`${doc_mag[keyName] === true ? classes.green : classes.red} ${keyName !== 'DocMag' ? classes.divider : null}`}
                                key={keyName}
                                role={undefined}
                                dense
                                button
                                disabled={keyName === 'DocMag' ? false : isReadOnly}
                                onClick={e => { this.setupChange(keyName, !doc_mag[keyName]) }}
                            >
                                <ListItemIcon className={keyName !== 'DocMag' ? classes.sub : null}>
                                    <Checkbox
                                        edge="start"
                                        // checked={checked.indexOf(value) !== -1}
                                        checked={doc_mag[keyName]}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={formatDocMag(keyName)} />
                            </ListItem>
                        );
                    })

                }

            </List>

        );

    }
}

ModuliDocMag.propTypes = {
    doc_mag: PropTypes.shape({}).isRequired,
    handleChangeFieldModulo: PropTypes.func.isRequired,

    isReadOnly: PropTypes.bool.isRequired
};

export default withStyles(styles)(ModuliDocMag);